// extracted by mini-css-extract-plugin
export default {"table":"sbcgO_iIjcskkygYFOWw"};